
















































































/* ----------------------------------------
    Imports
---------------------------------------- */

import { Component, Vue } from 'vue-property-decorator';

/* ----------------------------------------
    Parts
---------------------------------------- */

import Options from "@part/features/Options";

/* ----------------------------------------
    Icons
---------------------------------------- */

import DownIcon from "@icon/DownIcon";

/* ----------------------------------------
    Module
---------------------------------------- */

import anime from 'animejs';
import merge from 'lodash/merge';

/** ----------------------------------------
    JS Modules
 ---------------------------------------- */

import { Overlay } from '@js/module/Overlay';
const overlay = new Overlay(99999);

/* ----------------------------------------
    Transitions Popup
---------------------------------------- */

const openPopup = (el, back = true) => {
    anime({
        targets: el,
        opacity: [0, 1],
        scale: [1.1, 1],
        translateX: ['-50%', '-50%'],
        translateY: ['-50%', '-50%'],
        duration: 450,
        easing: 'easeOutQuad',
        begin: () => {
            el.style.display = 'flex';
            back && overlay.createOverlay();
        }
    });
};

const closePopup = (el, back = true) => {
    anime({
        targets: el,
        opacity: [1, 0],
        scale: [1, 1.075],
        duration: 550,
        easing: 'easeOutBack',
        complete: () => {
            el.style = '';
            back && overlay.removeOverlay();
        }
    });
};

/* ----------------------------------------
     Transitions
 ---------------------------------------- */

import * as transition from '@router/transitions/generic/fade'

/* ----------------------------------------
    Component
---------------------------------------- */

@Component({

    components: {
        DownIcon,
        Options
    },

    data() {
        return {
            active: false,
            types: {
                days: 'Day of the week',
                times: 'Part of day'
            },
            optionsPopup: null
        }
    },

    methods: {
        focused: function(e) {
            const input = e.currentTarget;
            const label = e.currentTarget.previousSibling;
            !input.value && transition.fadeOut(label, 250);
        },

        blurred: function(e) {
            const input = e.currentTarget;
            const label = e.currentTarget.previousSibling;
            !input.value && transition.fadeIn(label, 250);
        },

        selectedOption: function(data) {
            this.types[data.type] = data.content;
            transition.fadeOut(this.optionsPopup, 175);
            this.optionsPopup = null;
        },

        selectOption: function(type) {
            this.optionsPopup = this.$refs[type].$el;
            transition.fadeIn(this.optionsPopup, 175);
        },

        submit: function(e) {
            e.preventDefault();

            let data = {};

            const elements = this.$refs.form.querySelectorAll('input, select, textarea');

            for(let i = 0; i < elements.length; ++i ) {
                const element = elements[i];
                const name = element.name;
                const value = element.value;
                if(name) data[name] = value;
            }

            console.log('Submit:', merge(data, this.types));
        },

        togglePopup: function() {
            this.active = !this.active;
            const popup = this.$refs.popup;
            this.active ? openPopup(popup) : closePopup(popup);
        }
    },

    mounted() {
        this.$root.$on('popup-call', this.togglePopup);
    }

})

/* ----------------------------------------
    Export
---------------------------------------- */

export default class Popup extends Vue {}

